export const REALTY_TYPES = [
    {label:"Residência", value:"Residência"},
    {label:"Comércio", value:"Comércio"},
    {label:"Terreno Baldio", value:"Terreno Baldio"},
    {label:"Via Pública", value:"Via Pública"},
    {label:"Ponto Estratégico (P.E.)", value:"Ponto Estratégico"},
    {label:"Outros", value:"Outros"},
];